import React from "react";
import nzlvgaBanner from "../assets/images/nzlvga_banner3.jpeg";
import aboutImg from "../assets/images/about_img.jpg";
import './VideoPage.css';

function IndexVideoBPage() {
  return (
    <div className="container_12">
      <div className="grid_12">
        <div className="grid_12 alpha">
          <div className="box-3">
            <div className="gradient_1">
              <h2>关于NZLVGA</h2>
            </div>
            <div
              className="box-3_pad_3 p_text_lineheight"
              style={{
                fontSize: "18px",
                textIndent: "Video0px",
              }}
            >
<img src={aboutImg} alt="" />
<p className="p_text_body" style={{marginTop:"20px"}}>气排球是中国原发的一项群众性排球活动。它集运动、休闲、娱乐为一体，是一项深受欢迎的休闲体育运动项目，尤其是在中老年非专业人士中。
<br />
<br />
新西兰气排球协会总会New Zealand Light Volleyball General Association(NZLVGA)是首位引进并有组织推动气排球在新西兰发展的引领者。

<br />
<br />
成立于2020年，隶属于新西兰华人妇女联合基金会。历经四年的发展，为气排球在本地发展做出了突出的贡献。已有会员400余人，自由组合的运动队20余个。目前在奥克兰东区、中区、西区、北岸设有训练基地，每周周一、周三、周五、周六都安排有训练时间。协会拥有专业气排球教练、体能教练，在平日的训练中能够给到会员提供专业的指导。

<br />
<br />
各类赛事的组织让气排球运动更具娱乐性，提高了球友的参与度，也增强了协会的凝聚力。
<br />
<br />
每月月底都有为会员设计组织的积分赛，由赞助商冠名并提供奖品，协会负责组织，让会员每月都有切磋球技的机会。
<br />
<br />
举办每年一届的协会杯公开赛，是新西兰各个俱乐部共同参与的大型赛事，也是新西兰地区规模最大的气排球比赛之一。
<br />
<br />
星光杯国际气排球邀请赛，更是为加强国际间交流备受关注的大型赛事。2024年的星光杯国际邀请赛，除了奥克兰赛场外，更是增设了星光杯悉尼分站。未来将考虑设立更多世界其它城市的星光杯比赛站点。
<br />
<br />
2024年协会组织原住民气球队出访中国，参加中国国家体育总局在福建长泰举办的“中国气排球公开赛”，受益匪浅，反响热烈。
<br />
<br />
“快乐、健康、团结、进步”是新西兰气排球协会总会的宗旨，更是我们发展的方向。
<br />
<br />
我们的目标是“促进新西兰多元文化体育交流，增强各族裔大融合”。
<br />
<br />
为此，我们将继续努力让更多喜爱气排球的不同族裔加入我们，让更多的人受益，让气排球运动在新西兰发扬光大。
</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IndexVideoBPage;

